// config
import * as http from 'utils/http';
import config from 'config';
// utils

const getTicketDetail = async ({ id }) => {
  const data = await http.get(`${config.API_URL}price-negotiation/tickets/${id}/`);
  return data;
};

export default getTicketDetail;
